import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Preloader({ onDone }) {
    const [show, setShow] = useState(true);

    useEffect(() => {
        const t = setTimeout(() => {
            setShow(false);
            onDone(true);
        }, 2100);
        return () => clearTimeout(t);
    }, [onDone]);

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    data-testid="preloader"
                    className="fixed inset-0 z-[100] bg-obsidian flex flex-col items-center justify-center"
                    exit={{ y: "-100%" }}
                    transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
                >
                    <div className="mask-line">
                        <motion.span
                            initial={{ y: "110%" }}
                            animate={{ y: 0 }}
                            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
                            className="font-hindi text-gold-light text-3xl sm:text-5xl"
                        >
                            माँ गायत्री ज्वेलर्स
                        </motion.span>
                    </div>
                    <div className="mask-line mt-4">
                        <motion.span
                            initial={{ y: "110%" }}
                            animate={{ y: 0 }}
                            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.4 }}
                            className="eyebrow"
                        >
                            Maa Gayatri Jewellers · Supaul
                        </motion.span>
                    </div>
                    <motion.div
                        className="hairline w-40 mt-8"
                        initial={{ scaleX: 0 }}
                        animate={{ scaleX: 1 }}
                        transition={{ duration: 1.4, ease: "easeInOut", delay: 0.3 }}
                    />
                </motion.div>
            )}
        </AnimatePresence>
    );
}
